/* eslint-disable react/require-default-props */
import styled from 'styled-components';
import React from 'react';
import { Popover } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

const StyledLabel = styled.label`
    width: 40%;
    display: inline-block;
    font-size: 1.6em;
    vertical-align: center;
`;

const TooltipIcon = styled(QuestionCircleOutlined)`
    vertical-align: top;
    margin-top: 0.3em;
    margin-left: 0.5em;
`;

const InputLabel = ({ text = '', tooltip = null, style = {} }) => (
    <StyledLabel style={style}>
        {text}
        {tooltip && (
            <Popover placement="right" content={tooltip} trigger="click">
                <TooltipIcon />
            </Popover>
        )}
    </StyledLabel>
);

export default InputLabel;
